var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"po",attrs:{"id":"room3"}},[_vm._l((_vm.mode['elems']),function(elem){return [_c('elem',{attrs:{"mode":elem}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }